const BASE_URL = process.env.NODE_ENV === 'production' ? "https://finca-api.lyretech.dk" : process.env.NODE_ENV === 'development' ? "https://finca-backend-api.lyretech.dk" : "http://localhost";

export const API_URL = BASE_URL + "/api";
export const API_URL_V2 = BASE_URL + "/v2";